<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="header-content">
      <h2 ngpDialogTitle class="modal-title">
        {{ "move-copy-widget-dialog.popup.title" | translate }}
      </h2>

      <div class="mode-selector">
        <sui-select
          [ngModel]="selectedMode"
          (ngModelChange)="onModeChange($event)"
        >
          @for (mode of availableModes; track mode) {
            <sui-select-option [value]="mode.value" [label]="mode.label">{{
              mode.label
            }}</sui-select-option>
          }
        </sui-select>
      </div>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    @if (selectedMode === "same-dashboard") {
      <app-move-copy-same-dashboard
        [widgets]="widgets"
        [currentObject]="currentObject"
        (formValidityChange)="onFormValidityChange($event)"
      ></app-move-copy-same-dashboard>
    }

    @if (selectedMode === "same-feed") {
      <app-move-copy-same-feed
        [widgets]="widgets"
        [currentObject]="currentObject"
        (formValidityChange)="onFormValidityChange($event)"
      ></app-move-copy-same-feed>
    }

    @if (selectedMode === "other-dashboards") {
      <app-move-copy-other-dashboards
        [widgets]="widgets"
        [currentObject]="currentObject"
        (formValidityChange)="onFormValidityChange($event)"
      ></app-move-copy-other-dashboards>
    }

    @if (selectedMode === "other-feeds") {
      <app-move-copy-other-feeds
        [widgets]="widgets"
        [currentObject]="currentObject"
        (formValidityChange)="onFormValidityChange($event)"
      ></app-move-copy-other-feeds>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button variant="primary" [disabled]="!isValid()" (click)="save()">
      {{ "btn.confirm" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
